<template>
  <div :class="{'hidden':hidden}" >
    <el-pagination
      v-if="total === -1"
      key="noTotalP"
      :background="background"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="pageSizes"
      :page-size.sync="pageSize"
      :reset-page-no="true"
      :no-total="total === -1"
      :layout="layout"
    />
    <el-pagination
      v-else
      key="hasTotalP"
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
// import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50, 100, 500]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    },
    localKey: String,
    size: Number,
  },
  computed: {
    currentPage: {
      get() {
        // let page = this.updateLocal(true, 'page')
        return this.page
      },
      set(val) {
        // this.updateLocal(false, 'page', val) 
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        let pageSize = this.updateLocal(true, 'limit') 
        return pageSize||this.limit
      },
      set(val) {
        this.updateLocal(false, 'limit', val);
        this.$emit('update:limit', val)
      }
    },
    f_total({ currentPage: pageNo, pageSize, size }) {
      let cur_total = size || 0;
      return cur_total < pageSize ? pageNo * pageSize : (pageNo + 1) * pageSize;
    },
  },
  methods: {
    // 缓存当前分页大小
    updateLocal(isGet, key, val) {
      if(!this.localKey) return null;
      let localPage = JSON.parse(localStorage.getItem('localPage')||"{}");; 
      if(isGet) {
           let value = localPage[this.localKey]&&localPage[this.localKey][key]
          value&&this.$emit('update:'+key, value)
          return value||null
      }
      if(!localPage[this.localKey]){
        localPage[this.localKey] = {}
      }
      localPage[this.localKey][key] = val ;
      localStorage.setItem('localPage', JSON.stringify(localPage))
    },
    handleSizeChange(val) {
      this.$emit('pagination', { page: 1, limit: val })
      // if (this.autoScroll) {
      //   scrollTo(0, 800)
      // }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      // if (this.autoScroll) {
      //   scrollTo(0, 800)
      // }
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  /* padding-top: 15px; */
}
.pagination-container.hidden {
  display: none;
}
</style>
